import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {FormDataService} from './main-section/shared/form-data.service';
import {RightSideService} from './main-section/shared/right-side.service';
import {NavigationBarService} from './main-section/shared/navigation-bar.service';

@Injectable()
export class OnlySavedFirstTabGuard implements CanActivate {
  constructor(
    public rightSideService: RightSideService,
    private formDataService: FormDataService,
    private navBarService: NavigationBarService,
    private router: Router) {
  }

  canActivate() {
    if (!this.formDataService.getZerothTabData()) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}

@Injectable()
export class OnlySavedCategoryGuard implements CanActivate {
  constructor(private formDataService: FormDataService,
              private tabsService: RightSideService,
              private router: Router) {
  }

  canActivate() {
    if (this.formDataService.getFirstTabData() && !this.tabsService.getIsRedirected()) {
      return true;
    } else {
      if (this.tabsService.getCategoryName()) {
        this.router.navigate(['/' + this.tabsService.getCategoryName().toLowerCase().replace(/[^a-zA-Z]/g, '')]);
      } else {
        this.router.navigate(['/']);
      }
      return false;
    }
  }
}

@Injectable()
export class OnlySavedSecondTabGuard implements CanActivate {
  constructor(private formDataService: FormDataService,
              private router: Router,
              private tabsService: RightSideService) {
  }

  canActivate() {
    if (this.formDataService.getSecondTab() && !this.tabsService.getIsRedirected()) {
      return true;
    } else {
      this.router.navigate(['/cihaz-durumu']);
      return false;
    }
  }
}


@Injectable()
export class OnlySavedSellerTabGuard implements CanActivate {
  constructor(private formDataService: FormDataService,
              private router: Router,
              private tabsService: RightSideService) {
  }

  canActivate() {
    if (this.formDataService.getSeller() && !this.tabsService.getIsRedirected()) {
      return true;
    } else {
      this.router.navigate(['/iletisim-bilgileri']);
      return false;
    }
  }
}

@Injectable()
export class OnlySavedDeliveryTabGuard implements CanActivate {
  constructor(private formDataService: FormDataService,
              private router: Router,
              private tabsService: RightSideService) {
  }

  canActivate() {
    if (this.formDataService.getFourthTab() && !this.tabsService.getIsRedirected()) {
      return true;
    } else {
      this.router.navigate(['/teslimat-adimlari']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/route-guard.ts